import { QualityDetailForm, QualityDetailTaskItem } from '../../types/qualityPolicy';
import { emptyTask } from '../../utils/qualityPolicyForms';
import QualityDocMetaFields from './QualityDocMetaFields';

interface Props {
  year: number;
  value: QualityDetailForm;
  disabled?: boolean;
  onChange: (next: QualityDetailForm) => void;
  onSyncFromPlan?: () => void;
}

function QualityDetailFormView({ year, value, disabled, onChange, onSyncFromPlan }: Props) {
  const updateTask = (id: string, patch: Partial<QualityDetailTaskItem>) => {
    onChange({
      ...value,
      tasks: value.tasks.map((row) => (row.id === id ? { ...row, ...patch } : row)),
    });
  };

  const removeTask = (id: string) => {
    const next = value.tasks.filter((row) => row.id !== id);
    onChange({ ...value, tasks: next.length ? next : [emptyTask()] });
  };

  return (
    <div className="qform">
      <p className="qform-lead">
        {year}년 품질방침 세부 계획서 — 목표별 세부과제·방법·일정·KPI를 작성합니다.
      </p>

      <QualityDocMetaFields
        meta={value.meta}
        disabled={disabled}
        onChange={(meta) => onChange({ ...value, meta })}
      />

      <div className="qform-section">
        <div className="qform-section__head">
          <h3>세부 추진과제</h3>
          <div className="ncr-actions">
            {!disabled && onSyncFromPlan && (
              <button type="button" className="ncr-btn is-secondary" onClick={onSyncFromPlan}>
                추진계획 목표 불러오기
              </button>
            )}
            {!disabled && (
              <button
                type="button"
                className="ncr-btn is-secondary"
                onClick={() => onChange({ ...value, tasks: [...value.tasks, emptyTask()] })}
              >
                과제 추가
              </button>
            )}
          </div>
        </div>
        <div className="qform-table-wrap">
          <table className="qform-table qform-table--wide">
            <thead>
              <tr>
                <th>목표코드</th>
                <th>과제명</th>
                <th>추진방법</th>
                <th>담당</th>
                <th>시작</th>
                <th>종료</th>
                <th>KPI</th>
                <th>목표값</th>
                {!disabled && <th />}
              </tr>
            </thead>
            <tbody>
              {value.tasks.map((row) => (
                <tr key={row.id}>
                  <td>
                    <input
                      value={row.objectiveCode}
                      disabled={disabled}
                      placeholder="QO-01"
                      onChange={(e) => updateTask(row.id, { objectiveCode: e.target.value })}
                    />
                  </td>
                  <td>
                    <input
                      value={row.taskName}
                      disabled={disabled}
                      onChange={(e) => updateTask(row.id, { taskName: e.target.value })}
                    />
                  </td>
                  <td>
                    <input
                      value={row.method}
                      disabled={disabled}
                      onChange={(e) => updateTask(row.id, { method: e.target.value })}
                    />
                  </td>
                  <td>
                    <input
                      value={row.owner}
                      disabled={disabled}
                      onChange={(e) => updateTask(row.id, { owner: e.target.value })}
                    />
                  </td>
                  <td>
                    <input
                      type="date"
                      value={row.startDate}
                      disabled={disabled}
                      onChange={(e) => updateTask(row.id, { startDate: e.target.value })}
                    />
                  </td>
                  <td>
                    <input
                      type="date"
                      value={row.endDate}
                      disabled={disabled}
                      onChange={(e) => updateTask(row.id, { endDate: e.target.value })}
                    />
                  </td>
                  <td>
                    <input
                      value={row.kpi}
                      disabled={disabled}
                      onChange={(e) => updateTask(row.id, { kpi: e.target.value })}
                    />
                  </td>
                  <td>
                    <input
                      value={row.targetValue}
                      disabled={disabled}
                      onChange={(e) => updateTask(row.id, { targetValue: e.target.value })}
                    />
                  </td>
                  {!disabled && (
                    <td>
                      <button
                        type="button"
                        className="qform-row-del"
                        onClick={() => removeTask(row.id)}
                      >
                        삭제
                      </button>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="qform-section">
        <h3>필요 자원 / 지원사항</h3>
        <textarea
          rows={3}
          value={value.resourceNotes}
          disabled={disabled}
          onChange={(e) => onChange({ ...value, resourceNotes: e.target.value })}
          placeholder="인력, 설비, 교육, 예산 등"
        />
      </div>

      <div className="qform-section">
        <h3>비고</h3>
        <textarea
          rows={3}
          value={value.remarks}
          disabled={disabled}
          onChange={(e) => onChange({ ...value, remarks: e.target.value })}
        />
      </div>
    </div>
  );
}

export default QualityDetailFormView;
